'use strict';

/**
 *  @desc 公共方法库
 *  @create 2016-10-14
 *  @modify 2016-10-14
 *  @author wangkuan
 */
module.exports = {
    getParams: function getParams() {
        var index = location.href.indexOf('?');
        if (index < 0) {
            return {};
        }
        var url = decodeURIComponent(location.href);
        var strs = url.substr(index + 1).split('&');
        var p = {};
        for (var i = 0; i < strs.length; i++) {
            p[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
        }
        if (p.spm && p.spm.indexOf('#') > -1) {
            p.spm = p.spm.split('#')[0];
        }
        return p;
    },

    /**
     * @desc 转换对象成url
     */
    convertParamsToUrl: function convertParamsToUrl(obj) {
        var front = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        var encode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var arr = [];
        Object.keys(obj).forEach(function (k) {
            var value = encode ? encodeURIComponent(obj[k]) : obj[k];
            arr.push(k + '=' + value);
        });
        return front + arr.join('&') + end;
    },
    getAppFrom: function getAppFrom() {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('dafengche') > -1) {
            return 'dafengche';
        }
        if (ua.indexOf('cheniu') > -1) {
            return 'cheniu';
        }
        if (ua.indexOf('sccwk') > -1) {
            return 'sccwk';
        }
        if (ua.indexOf('buyerapp') > -1) {
            return 'buyerapp';
        }
        if (/MicroMessenger/i.test(ua) === true) {
            return 'weixin';
        }
        return '';
    },
    extend: function extend() {
        for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
            params[_key] = arguments[_key];
        }

        var obj = {};

        var _loop = function _loop(i) {
            Object.keys(params[i]).forEach(function (key) {
                if (params[i].hasOwnProperty(key)) {
                    obj[key] = params[i][key];
                }
            });
        };

        for (var i = 0; i < params.length; i++) {
            _loop(i);
        }
        return obj;
    },

    /**
     * @ desc 限制输入长度
     * @ value 输入值
     * @ num  限制长度
     * @ replaceStr 替换值
     */
    limitLenth: function limitLenth(value, num) {
        var replaceStr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '...';

        if (value.length <= num) {
            return value;
        }
        return value.substr(0, num) + replaceStr;
    },

    /**
     * 判断数组中对象的某个字段是否包含
     *
     * var a = [{
     *     id: 9
     * }];
     * var b = 9;
     * this.arrIndexOf(a, "id", b);
     * return 1
     */
    arrIndexOf: function arrIndexOf(arr, key, value) {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i][key] === value) {
                return i;
            }
        }
        return '';
    },

    /**
     * 生成独一无二的随机数 
     */
    getGuid: function getGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    },

    /**
     * 编码转换query为URL
     *
     * @param  Object   query  [参数对象]
     * @param  String   front  [前缀]
     * @param  String   end    [后缀]
     * 
     */
    encodeQueryToUrl: function encodeQueryToUrl(_ref) {
        var _ref$query = _ref.query,
            query = _ref$query === undefined ? {} : _ref$query,
            _ref$front = _ref.front,
            front = _ref$front === undefined ? '' : _ref$front,
            _ref$end = _ref.end,
            end = _ref$end === undefined ? '' : _ref$end;

        return this.convertParamsToUrl(query, front, end, true);
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/souche-util/lib/function.js
// module id = upc2
// module chunks = 11